import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { projectFeedFailingContestsBackend } from './project-feed-failing-contests.backend';
import { projectFeedFailingContestsReducer } from './project-feed-failing-contests.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectFeedFailingContests',
      projectFeedFailingContestsReducer,
    ),
    BackendModule.forFeature(
      'projectFeedFailingContests',
      projectFeedFailingContestsBackend,
    ),
  ],
})
export class DatastoreProjectFeedFailingContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-contests/project-feed-failing-contests.module.ts